import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';



// comingsoon
import ComingsoonImage from '../pages/comingsoon/comingsoon_image';
import ComingsoonSimple from '../pages/comingsoon/comingsoon_simple';

// error
import Error400 from '../pages/error/error400';
import Error401 from '../pages/error/error401';
import Error403 from '../pages/error/error403';
import Error404 from '../pages/error/error404';
import Error500 from '../pages/error/error500';
import Error503 from '../pages/error/error503';

import events from '../pages/running/events.vue'
import eventsDetail from '../pages/running/event_detail.vue'
import events_detail_wholesale from '../pages/running/event_detail_wholesale.vue'
import events_detail_manual from '../pages/running/event_detail_manual.vue'
import event_race_detail from '../pages/running/event_race_detail.vue'
import cart from '../pages/running/cart.vue'
import cart_wholesale from '../pages/running/cart_wholesale.vue'
import cart_manual from '../pages/running/cart_manual.vue'
import eventqr from '../pages/running/eventqr.vue'
import download from '../pages/running/download.vue'
import d from '../pages/running/download.vue'
import dcc from '../pages/running/download_creditcard.vue'
import dd from '../pages/running/download_direct.vue'

import howToOrder from '../pages/running/how_to_order.vue'
import findOrder from '../pages/running/findOrder.vue';
import about from '../pages/running/about.vue';
import terms_of_use from '../pages/running/terms_of_use.vue';
import how_to_use from '../pages/running/how_to_use.vue';
import refund_policy from '../pages/running/refund_policy.vue'

const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'events',
        component: events,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      }, {
        path: ':event_id',
        name: 'eventsDetail',
        component: eventsDetail,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },  
      {
        path: ':event_id/wholesale',
        name: 'events_detail_wholesale',
        component: events_detail_wholesale,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: ':event_id/manual',
        name: 'events_detail_manual',
        component: events_detail_manual,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/event/:event_id',
        name: 'event_race_detail',
        component: event_race_detail,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      }, 
      {
        path: "cart",
        name: "cart",
        component: cart,
        meta: {
          title: "SPORTACTION.PHOTOS",
        },

      },{
        path: "cart-wholesale",
        name: "cart_wholesale",
        component: cart_wholesale,
        meta: {
          title: "SPORTACTION.PHOTOS",
        },

      },{
        path: "cart-manual",
        name: "cart_manual",
        component: cart_manual,
        meta: {
          title: "SPORTACTION.PHOTOS",
        },

      },
      {
        path: "how-to-order",
        name: "howToOrder",
        component: howToOrder,
        meta: {
          title: "SPORTACTION.PHOTOS",
        },
      },
       {
        path: ':q/qr',
        name: 'eventqr',
        component: eventqr,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },{
        path: '/download/:q',
        name: 'download',
        component: download,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/d/:q',
        name: 'd',
        component: d,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/dcc/:q',
        name: 'dcc',
        component: dcc,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/dd/:q',
        name: 'dd',
        component: dd,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/about',
        name: 'about',
        component: about,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      }, 
      {
        path: '/find-order',
        component: findOrder,
        name: 'findOrder',
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      
      {
        path: '/terms-of-use',
        name: 'terms-of-use',
        component: terms_of_use,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/refund-policy',
        name: 'refund-policy',
        component: refund_policy,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      {
        path: '/how-to-use',
        name: 'how-to-use',
        component: how_to_use,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },
      
      {
        path: '/404',
        name: '404',
        component: Error404,
        meta: {
          title: 'SPORTACTION.PHOTOS',
        }
      },

    ]
  },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router